export default __webpack_public_path__ + "11b7b47daeb1d7a224c2c532290b8a48.jpg";